import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { newPath } from "../../../components/utilities/UtilityFunctions";
import { postNotification } from "../../../components/utilities/Notifications";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";

import { EventSoftScorePlayerEntry } from "./SubComponents/EventSoftScoreComponents";

export default function EventPlayerSoftScores(props) {
  const { activeTab, setActiveTab, event } = props;
  const navigate = useNavigate();

  const [player, setPlayer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        if (!event?.player) {
          postNotification(
            "warning",
            "You are not an active player for this event."
          );
          let path = newPath({
            active_tab: "overview",
          });
          setActiveTab(0);
          navigate(path, { replace: false });
          return;
        }
        if (!event?.softScores?.filter((el) => el.playerScored)) {
          postNotification(
            "warning",
            "This event has no player scored soft scores."
          );
          let path = newPath({
            active_tab: "overview",
          });
          setActiveTab(0);
          navigate(path, { replace: false });
          return;
        }

        setPlayer(event.player);
      } catch (err) {
        postNotification("error", err);
      }
      setLoading(false);
    };
    check();
    // eslint-disable-next-line
  }, [activeTab, event]);

  return (
    <>
      {player && (
        <EventSoftScorePlayerEntry
          event={event}
          player={player}
          setPlayer={setPlayer}
          activeRound={event.currentRound}
        />
      )}
      {loading && <ModalLoadingFull />}
    </>
  );
}
